@if (gridOptions) {
  <dv-grid [actions]="actions()">
    <ag-grid-angular
      vtGridWithSidesheet
      dvPinSelectedRow
      class="ag-theme-devinco"
      [gridOptions]="gridOptions"
      (selectionChanged)="onSelectionChanged($event)"
      (modelUpdated)="onModelUpdated($event)">
    </ag-grid-angular>
  </dv-grid>
}
